import type { LogEntry } from 'shared/services/logger/logger.types'

import type { ConditionOperator, FilterCondition } from './logViewer.types'

export function evaluateCondition(
  entry: LogEntry,
  cond: FilterCondition
): boolean {
  if (cond.field === 'payload_field') {
    const key = cond.payloadKey.trim()
    if (!key) return true
    if (cond.operator === 'exists') return key in entry.payload
    if (cond.operator === 'not_exists') return !(key in entry.payload)
    const raw = entry.payload[key]
    const subject = raw != null ? String(raw).toLowerCase() : ''
    return applyStringOp(subject, cond.operator, cond.value)
  }

  const subject =
    cond.field === 'event'
      ? entry.event.toLowerCase()
      : JSON.stringify(entry.payload).toLowerCase()

  return applyStringOp(subject, cond.operator, cond.value)
}

function applyStringOp(
  subject: string,
  op: ConditionOperator,
  rawValue: string
): boolean {
  const v = rawValue.toLowerCase()
  switch (op) {
    case 'contains':
      return subject.includes(v)
    case 'not_contains':
      return !subject.includes(v)
    case 'equals':
      return subject === v
    case 'not_equals':
      return subject !== v
    case 'starts_with':
      return subject.startsWith(v)
    case 'ends_with':
      return subject.endsWith(v)
    default:
      return true
  }
}

export function toDatetimeLocalValue(ts: number): string {
  const d = new Date(ts)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function formatTimestamp(ts: number): string {
  return new Date(ts).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  })
}

export function formatDate(ts: number): string {
  return new Date(ts).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}
